import { Component, OnInit, Input } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as _ from 'lodash';
import { EmpowerModernLifeService } from 'src/services/empower-services/empower-modern-life.service';
import { EmpowerExportService } from 'src/services/empower-services/empower-export.service';
import { generateTitleDiv, NO_IMAGE, undefinedImagePath } from 'src/modules/empower-module/helper';

@Component({
  selector: 'empower-pca-inc-rev-opper',
  templateUrl: './pca-inc-rev-opper.component.html',
  styleUrls: ['./pca-inc-rev-opper.component.scss']
})
export class EmpowerPcaIncRevOpperComponent implements OnInit {
  @Input() data?: any;
  _unsubscribeAll = new Subject();
  undefinedImagePath = '';

  chartCaption: string;
  xaxisCatgoryList: any = [];
  dataSeries: any = [];
  dialValue: any;
  yearlyIncrease: any = 0;
  innerHtml = '';
  pageComment: string;

  constructor(
    public empowerModernLifeService: EmpowerModernLifeService, private empowerExportService: EmpowerExportService,
    private spinner: NgxSpinnerService,
  ) {
  }

  ngOnInit(): void {
    this.initPageData();
  }

  initPageData() {
    if (this.data) {
      this.data = JSON.parse(this.data);

      this.innerHtml = generateTitleDiv(this.data);
      this.checkPageState(this.data.pageId);
    }
  }

  checkPageState(pageId) {
    const daxReponse = this.empowerModernLifeService.getPagesState(pageId);
    this.pageComment = this.empowerModernLifeService.getPageCommentState(pageId);
    if (daxReponse && daxReponse.length) {
      this.loadVisuals(daxReponse);
    } else {
      this.executePageDaxQuery();
    }
  }

  executePageDaxQuery() {
    const payload = {
      reportId: this.data.reportId,
      pageId: this.data.pageId,
      ...this.empowerModernLifeService.getDashboardState()
    };
    this.spinner.show();
    this.empowerModernLifeService.ExecutePageDaxQuery(payload).pipe(takeUntil(this._unsubscribeAll)).subscribe(response => {
      this.spinner.hide();
      if (response && response.length) {
        this.getDAXReponseData(response);
      } else {
        this.emitExportEvent(true);
      }
    },
      err => {
        this.undefinedImagePath = undefinedImagePath;
        this.spinner.hide();
      });
  }

  getDAXReponseData(response) {
    const daxReponse = response.map(a => {
      return {
        visualId: a.visualId,
        daxResponse: a.daxResponse ? JSON.parse(a.daxResponse) : []
      }
    });
    console.log(daxReponse);
    this.setPageState(this.data.pageId, daxReponse);
    this.loadVisuals(daxReponse);
  }

  setPageState(pageId, daxData) {
    this.empowerModernLifeService.setPagesState(pageId, daxData);
  }

  loadVisuals(daxData) {
    this.loadFirstVisualData(daxData[1]);
    this.loadSecondVisualData(daxData[0]);
    this.emitExportEvent(true);
  }

  loadFirstVisualData(visualData) {
    const dataList = _.orderBy(visualData.daxResponse, ['dIM_DATE_COMP[FISCAL_MONTH_NUMBER]'], ['asc']);
    const categoryList = _.map(dataList, a => { return { label: a['dIM_DATE_COMP[FISCAL_MONTH_NAME]'] } });
    const licencesSeriesData = _.map(dataList, a => { return { value: a['[STLicsQty___Comp_Date]'] } });
    const pcUnitsSeriesData = _.map(dataList, a => { return { value: a['[Retailer_PC_Units___Comp_Date]'] } });
    const attachSeriesData = _.map(dataList, a => { return { value: a['[Attach Retail PC Units]'] } });
    this.xaxisCatgoryList = categoryList;
    this.dataSeries = [
      {
        seriesname: 'Accessories',
        data: licencesSeriesData
      },
      {
        seriesname: 'PC Units',
        data: pcUnitsSeriesData
      },
      {
        seriesname: 'Attach Retail PC Units',
        renderas: "line",
        parentyaxis: "S",
        data: attachSeriesData
      }
    ];
  }

  emitExportEvent(resolvedState: boolean) {
    setTimeout(() => {
      this.data && this.data.export && this.empowerExportService.setExportComponentSubject(51, resolvedState, this.data.pageIndex, this.data.pageTitle);
    }, 1000);
  }

  loadSecondVisualData(visualData) {
    this.yearlyIncrease = Number(_.get(visualData.daxResponse, ['0', '[1 % Attach Retailer Revenue]'], 0)).toFixed();
  }

  pageCommentChange(comment) {
    this.setPageCommentState(this.data.pageId, comment);
  }

  setPageCommentState(pageId, comment) {
    this.empowerModernLifeService.setPageCommentState(pageId, comment);
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
